import { Bot, Zap, FileText, Globe, Layout, MessageSquare, Shield, TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const services = [
  {
    icon: Bot,
    title: "Custom AI Chatbot",
    description: "Intelligent conversational agents trained on your specific business data with system prompts, knowledge base, and easy embed instructions."
  },
  {
    icon: Zap,
    title: "Workflow Automation",
    description: "Connect your apps and automate repetitive tasks. Get Make/Zapier/n8n recipes, workflow diagrams, and integration guides."
  },
  {
    icon: Shield,
    title: "Compliance & Policy Pack",
    description: "Terms of Service, Privacy Policy, Refund Policy, claims-safe marketing copy, and legal disclaimers tailored to your business type."
  },
  {
    icon: TrendingUp,
    title: "Website & Conversion Tune-Up",
    description: "Landing page copy rewrite, CTA improvements, SEO meta tags, headings plan, FAQ, trust sections, and do/don't claim guidelines."
  },
  {
    icon: Layout,
    title: "AI Website & Landing Page Builder",
    description: "AI-generated website copy, landing page sections, and React templates ready to deploy."
  },
  {
    icon: MessageSquare,
    title: "Chatbot + Knowledge Base Setup",
    description: "Deploy a custom chatbot trained on your docs, FAQs, and business data with embed instructions."
  }
];

export function Services() {
  return (
    <section id="services" className="py-24 bg-background/50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Services</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Comprehensive AI solutions designed to scale your business operations.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card key={index} className="bg-card/50 border-white/5 backdrop-blur-sm hover:border-primary/50 transition-colors duration-300">
              <CardHeader>
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                  <service.icon className="w-6 h-6 text-primary" />
                </div>
                <CardTitle className="text-xl">{service.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">{service.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
